export default "__VITE_ASSET__Bmzw5bjL__"